import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const hasStatisticsConsent = () => window.Cookiebot?.consent?.statistics === true;

const sendPageView = () => {
    if (!hasStatisticsConsent() || typeof window.gtag !== "function") return;
    window.gtag("event", "page_view", {
        page_title: document.title,
        page_location: window.location.href,
        page_path: `${window.location.pathname}${window.location.search}${window.location.hash}`,
    });
};

export const AnalyticsPageViews = () => {
    const location = useLocation();

    useEffect(() => {
        sendPageView();
        window.addEventListener("CookiebotOnAccept", sendPageView);
        return () => window.removeEventListener("CookiebotOnAccept", sendPageView);
    }, [location.pathname, location.search, location.hash]);

    return null;
};
